module.exports = __webpack_public_path__ + "img/Ficha tecnica_hover_en.07bb834a.svg";